import Vue from 'vue'
import Router from 'vue-router'
import * as h from '@/utilities/router-helpers'

import Battles from './views/Battles'
import Battle from './views/Battle'
import Favourites from './views/Favourites'
import store from './store/index'

Vue.use(Router)

const router = new Router({
  mode: `history`,
  base: process.env.BASE_URL,
  routes: [
    {
      path: `*`, // catch-all
      redirect: `/battles`,
    },
    {
      path: `/`,
      name: `home`,
      component: Battle,
      props: ({ params }) => ({
        battleId: window.localStorage.getItem(`recentBattle`),
        skipAnimation: params.skipAnimation,
      }),
      beforeEnter: h.accessIfBattleSet,
    },
    {
      path: `/battles`,
      name: `battles`,
      component: Battles,
    },
    {
      path: `/favourites`,
      name: `favourites`,
      component: Favourites,
      meta: { requiresAuth: true },
      beforeEnter: h.accessIfLoggedIn,
    },
    {
      path: `/account`,
      name: `account`,
      // route level code-splitting generates a separate chunk
      // (account.[hash].js) for this route which is lazy-loaded
      // when the route is visited.
      component: () => import(`./views/Account`),
      meta: { requiresAuth: true },
      beforeEnter: h.accessIfLoggedIn,
    },
    {
      path: `/battles/:battle`,
      name: `battle`,
      component: Battle,
      props: ({ params }) => ({
        battleId: params.battle,
        skipAnimation: params.skipAnimation,
      }),
      beforeEnter: h.storeBattle,
    },
    {
      path: `/login`,
      name: `login`,
      component: () => import(`./views/Login`),
      beforeEnter: h.redirectIfLoggedIn(`account`),
    },
    {
      path: `/signup`,
      name: `signup`,
      component: () => import(`./views/Signup`),
      beforeEnter: h.redirectIfLoggedIn(`account`),
    },
    {
      path: `/logout`,
      name: `logout`,
      beforeEnter: async (to, from, next) => {
        await store.dispatch(`accounts/logout`)
        next(from)
      },
    },
    {
      path: `/combatants/:id`,
      name: `combatants`,
      component: () => import(`./views/CombatantSheet`),
      props: ({ params }) => ({ id: params.id, loggedIn: h.loggedIn }),
    },
    {
      path: `/bestiary/:name`,
      name: `monster`,
      component: () => import(`./views/MonsterSheet`),
      props: ({ params }) => ({ name: params.name, loggedIn: h.loggedIn }),
      meta: { requiresAuth: true },
      beforeEnter: h.accessIfLoggedIn,
    },
    {
      path: `/bestiary`,
      name: `bestiary`,
      component: () => import(`./views/Bestiary`),
      meta: { requiresAuth: true },
      beforeEnter: h.accessIfLoggedIn,
    },
  ],
})

export default router
